const s = require("./coreMap.module.scss");

import { default as React } from "react";
import { WithTranslation, withTranslation } from "react-i18next";
import classNames from "classnames";
import { CardStyle } from "./content";

interface OwnProps {
    row: number;
    col: number;
    height: number;
    width: number;
    code: string;
    max: number;
    min: number;
    cardStyle: CardStyle;
}

const Country = (props: OwnProps & WithTranslation) => {

    const elementHeight = props.cardStyle.elementHeight;
    const elementWidth = props.cardStyle.elementWidth;
    const margin = props.cardStyle.margin;

    const top = (props.row - 1) * (elementHeight + margin);
    const left = (props.col - 1) * (elementWidth + margin);
    const width = (props.width * (elementWidth + margin)) - margin;
    const height = (props.height * (elementHeight + margin)) - margin;
    return (
        <div className={classNames("shadow-sm", "bg-white", "rounded", s.country)} style={{
            /*left: left + "px",
            top: top + "px",
            width: width + "px",
            height: height + "px"*/
            gridColumn: props.col + " / span " + props.width,
            gridRow: props.row + " / span " + props.height,
        }}>
            <div className={s.title}>{props.t("common_country:" + props.code)}</div>
            <table className={s.table}>
                <tbody>
                    <tr><th>{props.t("page_coreMap:export")}</th><td className="alignRight">{props.max}</td></tr>
                    <tr><th>{props.t("page_coreMap:import")}</th><td className="alignRight">{props.min}</td></tr>
                </tbody>
            </table>
        </div>
    );
};

const translated = withTranslation("page_coreMap")(Country);

export default translated;